import { createSelector } from 'reselect';
import { FLAGS } from '@commons/fwf/constants';
import { flagTracker } from '@commons/fwf/flagTracker';
import { getFlagFromState } from '@funWithFlags/selectors';
import isVariation from '../utils/isVariation';

const getShopDetailsPickupFlag = createSelector(
  state => getFlagFromState(state, FLAGS.SHOP_DETAILS_PICKUP.KEY),
  flag => {
    flagTracker(flag, FLAGS.SHOP_DETAILS_PICKUP.KEY);
    return isVariation(flag);
  },
);

export default getShopDetailsPickupFlag;
